import React from "react";

const Notify = ({ style, pathStyle = {} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.726"
      height="24.767"
      viewBox="0 0 22.726 24.767"
      style={style}
    >
      <path
        id="Tracciato_340"
        data-name="Tracciato 340"
        d="M11.806,1.476v.885a7.383,7.383,0,0,1,5.9,7.231v.867a8.867,8.867,0,0,0,2.237,5.884l.341.383a1.476,1.476,0,0,1-1.1,2.458H1.476a1.477,1.477,0,0,1-1.1-2.458l.342-.383a8.858,8.858,0,0,0,2.237-5.884V9.592a7.342,7.342,0,0,1,5.9-7.231V1.476a1.476,1.476,0,0,1,2.952,0M10.33,22.767A2.952,2.952,0,0,1,8.241,21.9a3.026,3.026,0,0,1-.862-2.089h5.9a2.944,2.944,0,0,1-2.952,2.952"
        transform="translate(1.032 1)"
        fill="none"
        stroke="#000"
        stroke-width="2"
        style={pathStyle}
      />
    </svg>
  );
};

export default Notify;
